<template>
  <div class="main_box">
    <div class="head_box">
      <template v-if="$name === 'cy'">
        <img
          class="bylogo"
          style="width: 40px; height: auto"
          src="@/assets/img/cylogo.jpg"
        />
        <p class="tit">{{ "创宇新材料" }} 5G + 工业互联网平台</p>
      </template>
      <template v-else-if="$name === 'xx'">
        <img class="logo" src="@/assets/img/xxlogo.jpg" />
        <p class="tit">5G + 工业互联网平台</p>
      </template>
      <template v-else-if="$name === 'by'">
        <img
          class="bylogo"
          style="width: 40px; height: auto"
          src="@/assets/img/bylogo.jpg"
        />
        <p class="tit">{{ "铂悦厨业" }} 5G + 工业互联网平台</p>
      </template>
      <template v-else-if="$name === 'zq'">
        <img class="logo" src="@/assets/img/zqlogo.jpg" />
      </template>
      <template v-else-if="$name === 'ht'">
        <img
          class="bylogo"
          style="width: 40px; height: auto"
          src="@/assets/img/htlogo.jpg"
        />
        <p class="tit">{{ "海通塑胶" }} 5G + 工业互联网平台</p>
      </template>
      <template v-else-if="$name === 'ps'">
        <img
          class="bylogo"
          style="width: 40px; height: auto"
          src="@/assets/img/pslogo.jpg"
        />
        <p class="tit">{{ "鹏盛科技" }} 5G + 工业互联网平台</p>
      </template>
      <template v-else-if="$name === 'rrf'">
        <img
          class="bylogo"
          style="width: 40px; height: auto"
          src="@/assets/img/rrflogo.jpg"
        />
        <p class="tit">{{ "人人福食品" }} 5G + 工业互联网平台</p>
      </template>
      <template v-else-if="$name === 'abl'">
        <img
          class="bylogo"
          style="width: 40px; height: auto"
          src="@/assets/img/abllogo.jpg"
        />
        <p class="tit">{{ "安百林家具" }} 5G + 工业互联网平台</p>
      </template>
      <template v-else-if="$name === 'wt'">
        <img
          class="bylogo"
          style="width: 40px; height: auto"
          src="@/assets/img/wtlogo.jpg"
        />
        <p class="tit">{{ "微特电机" }} 5G + 工业互联网平台</p>
      </template>
      <template v-else-if="$name === 'cn'">
        <img
          class="bylogo"
          style="width: 60px; height: auto"
          src="@/assets/img/cnlogo.jpg"
        />
        <p class="tit">{{ "楚南新材料" }} 5G + 工业互联网平台</p>
      </template>
      <template v-else-if="$name === 'xy'">
        <img
          class="bylogo"
          style="width: 40px; height: auto"
          src="@/assets/img/xy.jpg"
        />
        <p class="tit">{{ "鑫翊新材料" }} 5G + 工业互联网平台</p>
      </template>
    </div>
    <div
      class="moudle_box"
      v-for="(menu, menuIndex) in getMenuList"
      :key="menuIndex"
      :class="`moudle_box${(menuIndex % 6) + 1}`"
      @click="toMenu(menu.children[0])"
    >
      <div class="moudle_box_head">
        <i
          v-if="menu.icon"
          :class="menu.icon"
          style="margin-right: 5px; font-size: 18px"
          :style="getIconStyle(menu.icon)"
        ></i>
        {{ getName(menu.menuName) }}
      </div>
    </div>
    <!-- <div
      class="moudle_box"
      v-for="(menu, menuIndex) in Arr"
      :key="menuIndex"
      :class="`moudle_box${(menuIndex % 6) + 1}`"
      @click="toMenu(menu.children[0])"
    >
      <div class="moudle_box_head">
        <i
          v-if="menu.icon"
          :class="menu.icon"
          style="margin-right: 5px; font-size: 18px"
          :style="getIconStyle(menu.icon)"
        ></i>
        {{ getName(menu.menuName) }}
      </div>
    </div> -->
    <!-- <div
      class="moudle_box"
      :class="`moudle_box${(getMenuList.length % 6) + 1}`"
      @click="toMenu()"
    >
      <div class="moudle_box_head">
        IOT物联网平台
      </div>
    </div> -->
    <!-- <div class="moudle_box moudle_box2"></div>
    <div class="moudle_box moudle_box3"></div>
    <div class="moudle_box moudle_box4"></div>
    <div class="moudle_box moudle_box5"></div> -->
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import projectConfig from "@/core/config";

export default {
  data() {
    return {
      isCollapse: false,
      collapseLeft: "200px",
      showCollapseBtn: true,
      nameObj: {
        仓储: "WMS",
        生产: "ERP",
        在线表单: "低代码平台",
        流程: "流程管理系统",
        系统: "配置中心",
        数据可视化: "IOT物联网平台",
      },
      // logoImage: require("../../../../assets/img/logo.png"),

      Arr: [
        { menuName: "ERP" },
        { menuName: "MES" },
        { menuName: "WMS" },
        // { menuName: "QMS" },
        { menuName: "设备管理" },
        { menuName: "数据采集" },
        { menuName: "基础信息管理" },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getMultiTags",
      "getMenuList",
      "getCollapse",
      "getCurrentMenuPath",
      "getCurrentMenuId",
      "getMultiColumn",
    ]),
  },
  methods: {
    getName(name) {
      let newName = name;
      for (const key in this.nameObj) {
        if (name.indexOf(key) != -1) {
          newName = this.nameObj[key];
        }
      }
      return newName;
    },
    toMenu(item, i) {
      console.log(item);
      this.setCurrentMenuId(item.menuId);
      this.$router.push({ name: "main" });
    },
    getIconStyle(isShow) {
      if (isShow && this.isChild) {
        return [{ "margin-left": "13px" }];
      }
    },
    getTextStyle(isShow) {
      if (isShow && this.isChild) {
        return [{ "padding-left": "13px" }];
      }
    },
    onCollapseChange() {
      this.showCollapseBtn = false;
      setTimeout(() => {
        this.setCollapse(!this.getCollapse);
        this.collapseLeft = this.getCollapse ? "65px" : "200px";
        this.showCollapseBtn = true;
      }, 100);
    },
    getProjectName() {
      if (this.getCollapse) {
        return projectConfig.projectName.substr(0, 1);
      } else {
        return projectConfig.projectName;
      }
    },
    ...mapMutations(["setCollapse", "clearAllTags", "setCurrentMenuId"]),
  },
  mounted() {
    console.log("getMenuList", this.getMenuList);
  },
};
</script>

<style lang="scss" scoped>
.main_box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  box-sizing: border-box;

  .head_box {
    width: 100%;
    height: 60px;
    padding-left: 20px;
    display: flex;
    align-items: center;
    font-size: 30px;
    color: #333;

    .logo {
      height: 45px !important;
    }
    .bylogo {
      width: 40px !important;
      height: auto !important;
    }

    .tit {
      margin-left: 10px;
    }
  }

  .moudle_box {
    // width: 455px;
    // height: 300px;
    width: 250px;
    height: 180px;
    background: linear-gradient(45deg, #5b93ff, rgba(91, 147, 255, 0.2));
    color: #fff;
    margin: 10px;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 10px;
    cursor: pointer;

    .moudle_box_head {
      height: 40px;
      font-size: 24px;
      cursor: pointer;
    }

    .menu_item {
      height: 32px;
      font-size: 18px;
      line-height: 32px;
      cursor: pointer;
    }
  }

  .moudle_box2 {
    background: linear-gradient(45deg, #ffc227, rgba(255, 194, 39, 0.3));
  }
  .moudle_box3 {
    background: linear-gradient(45deg, #ff8f6b, rgba(255, 143, 107, 0.3));
  }
  .moudle_box4 {
    background: linear-gradient(45deg, #26c0e2, rgba(38, 192, 226, 0.3));
  }
  .moudle_box5 {
    background: linear-gradient(45deg, #ff5bef, rgba(255, 91, 239, 0.3));
  }
  .moudle_box6 {
    background: linear-gradient(45deg, #18caa6, rgba(24, 202, 166, 0.3));
  }
}
</style>
